"use client"
import { useAuth0 } from "@auth0/auth0-react"
import { Button } from "@chakra-ui/react"

const LoginButton = ({ children = "Log In", ...buttonProps }) => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0()

  // While Auth0 rehydrates, avoid flashing the Log In button
  if (isLoading || isAuthenticated) {
    return null
  }

  return (
    <Button
      size="sm"
      colorPalette="teal"
      {...buttonProps}
      onClick={() => {
        const returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`
        loginWithRedirect({
          appState: { returnTo },
          authorizationParams: {
            redirect_uri: window.location.origin,
          }
        })
      }}
    >
      {children}
    </Button>
  )
}

export default LoginButton
